// Mutations del supervisor sobre un paro individual (S2).
//
// Feature-local, mismo criterio que correccionesParoQueries.ts. Ambas
// mutations invalidan la raíz ['supervisor'] entera porque corregir cambia
// minutos_perdidos (columna GENERATED) y eso mueve los KPIs del dashboard y del
// detalle de línea — no alcanza con invalidar la pantalla actual.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  paroSupervisorConfirmadoResponseSchema,
  paroSupervisorConfirmarSchema,
  paroSupervisorCorregidoResponseSchema,
  paroSupervisorCorregirSchema,
  type ParoSupervisorConfirmar,
  type ParoSupervisorCorregir,
} from 'schemas';
import { apiPatch } from '../../lib/api/client';
import { correccionesParoKeys } from './correccionesParoQueries';

/**
 * Invalida el rol completo + la bandeja de correcciones: corregir puede dejar
 * obsoleta una propuesta viva del técnico, y esa propuesta desaparece de la
 * bandeja en el mismo movimiento.
 */
function useInvalidarSupervisor() {
  const qc = useQueryClient();
  return () => {
    void qc.invalidateQueries({ queryKey: correccionesParoKeys.root });
    void qc.invalidateQueries({ queryKey: ['supervisor'] });
  };
}

export function useCorregirParoSupervisor() {
  const invalidar = useInvalidarSupervisor();
  return useMutation({
    mutationFn: (args: { paroId: string; input: ParoSupervisorCorregir }) =>
      apiPatch(
        `/api/supervisor/paros/${args.paroId}/corregir`,
        paroSupervisorCorregirSchema.parse(args.input),
        paroSupervisorCorregidoResponseSchema,
      ),
    onSuccess: invalidar,
  });
}

export function useConfirmarParoSupervisor() {
  const invalidar = useInvalidarSupervisor();
  return useMutation({
    mutationFn: (args: { paroId: string; input: ParoSupervisorConfirmar }) =>
      apiPatch(
        `/api/supervisor/paros/${args.paroId}/confirmar`,
        paroSupervisorConfirmarSchema.parse(args.input),
        paroSupervisorConfirmadoResponseSchema,
      ),
    onSuccess: invalidar,
  });
}
